export const GALLERY_MAX_IMAGES = 20;

/**
 * Photos upload at full resolution, so this only catches the outliers. Must
 * stay under the Cloudinary plan's own per-image ceiling, which rejects the
 * upload with an error the user cannot act on.
 */
export const GALLERY_MAX_FILE_BYTES = 20 * 1024 * 1024;
